__webpack_require__.p = "/Neural-Network-Character-Recognition/";